import Ordinance from './Ordinance'

export default class SealingToSpouseOrdinance extends Ordinance {
  constructor(sealingToSpouses, t) {
    super({
      data: sealingToSpouses,
      title: t('wcf.person-ordinances.sealingtospouse', 'Sealing to Spouse'),
      t,
    })
  }
}
